var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKavaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7523 25.7717C25.4853 25.8016 25.324 25.8344 25.1626 25.8344C23.9954 25.8344 22.8283 25.8524 21.6631 25.8235C21.4201 25.8099 21.1924 25.7025 21.0298 25.5248C18.6346 22.4787 16.2597 19.4147 13.8726 16.3637C13.6067 16.0261 13.6107 15.812 13.8817 15.4675C16.2566 12.4493 18.6031 9.40827 20.9781 6.3901C21.1535 6.18255 21.405 6.05094 21.6784 6.02366C22.877 5.98582 24.0787 6.00374 25.2783 6.00773C25.4349 6.02339 25.59 6.05136 25.7421 6.09137C25.6224 6.28057 25.5483 6.41997 25.4529 6.54345C23.1524 9.53606 20.8502 12.526 18.5463 15.5133C18.3088 15.82 18.3119 16.0212 18.5463 16.3289C20.859 19.3102 23.1622 22.2975 25.4559 25.2908C25.5483 25.4182 25.6153 25.5497 25.7523 25.7717Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9365 15.9434C11.9365 19.0282 11.9244 22.1071 11.9475 25.1889C11.9475 25.7004 11.7817 25.8556 11.2893 25.8387C10.4713 25.8089 9.65027 25.8178 8.83026 25.8288C8.48055 25.8288 8.32177 25.7372 8.3278 25.3501C8.33651 19.071 8.33651 12.7912 8.3278 6.51081C8.3278 6.13963 8.47351 6.01325 8.83026 6.01325C9.66635 6.02221 10.5044 6.03515 11.3425 6.00131C11.845 5.98141 11.9535 6.1874 11.9505 6.64514C11.9344 9.7439 11.9425 12.8427 11.9425 15.9414L11.9365 15.9434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKavaWhite);
export default __webpack_public_path__ + "static/media/kava-white.a12b5837d2c4db879e7a6569d391ff0a.svg";
export { ForwardRef as ReactComponent };